var image_upload_default = {
  "container": "EFan3",
  "disabled": "zgqlH",
  "imageInput": "mIj4i",
  "overlay": "ed-2M",
  "text": "ieeN8",
  "shown": "itudm",
  "hide": "RnhFp",
  "spinner": "qS5Ty",
  "spin": "hwY6S"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
